<div style="background: white; border-radius: 14px; overflow: hidden; transition: all 0.2s ease;"
  [style.border]="isExpanded ? '2px solid #1C593D' : (cuenta?.seleccionado ? '2px solid #1C593D' : '1px solid #e5e7eb')"
  [style.box-shadow]="isExpanded ? '0 4px 16px rgba(28,89,61,0.1)' : '0 1px 3px rgba(0,0,0,0.06)'">

  <!-- Header siempre visible (clickable en mobile para expandir) -->
  <div style="padding: 14px 16px; display: flex; align-items: center; justify-content: space-between; cursor: pointer;"
    [style.background]="isExpanded ? '#f0fdf4' : 'white'">

    <!-- Info principal -->
    <div style="display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0;">
      <!-- Icono banco -->
      <div style="display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;"
        [style.background]="cuenta?.banco?.codigoBanco === 'ZELLE' ? '#fef3c7' : '#eff6ff'">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px; flex-shrink: 0;"
          [style.color]="cuenta?.banco?.codigoBanco === 'ZELLE' ? '#f59e0b' : '#2563eb'">
          {{ cuenta?.banco?.codigoBanco === 'ZELLE' ? 'flash_on' : 'account_balance' }}
        </mat-icon>
      </div>

      <!-- Nombre + banco -->
      <div style="min-width: 0; flex: 1;">
        <p style="font-weight: 700; font-size: 0.9rem; color: #111827; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ cuenta?.nombre }}
        </p>
        <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-top: 2px;">
          <span style="font-size: 0.78rem; color: #6b7280;">{{ cuenta?.banco?.nombre }}</span>
          <span style="display: inline-flex; align-items: center; gap: 3px; background: #f0fdf4; border: 1px solid #bbf7d0; padding: 1px 8px; border-radius: 12px; font-size: 0.65rem; font-weight: 600; color: #1e5a3f;">
            {{ cuenta?.esEmpresa ? 'Empresa' : 'Individuo' }}
          </span>
        </div>
      </div>
    </div>

    <!-- Identificador desktop -->
    <div class="hidden lg:flex" style="align-items: center; gap: 6px; margin-left: 16px; min-width: 180px;">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280; flex-shrink: 0;">alternate_email</mat-icon>
      <span style="font-size: 0.8rem; color: #374151;">{{ cuenta?.identificador }}</span>
    </div>

    <!-- Número de cuenta desktop (solo BOFA) -->
    <div *ngIf="cuenta?.banco?.codigoBanco !== 'ZELLE' && cuenta?.numeroCuenta" class="hidden lg:flex" style="align-items: center; gap: 6px; margin-left: 16px; min-width: 140px;">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280; flex-shrink: 0;">credit_card</mat-icon>
      <span style="font-size: 0.8rem; color: #374151;">{{ cuenta?.numeroCuenta }}</span>
    </div>

    <!-- Acciones desktop (siempre visibles en lg+) -->
    <div class="hidden lg:flex" style="gap: 6px; align-items: center; margin-left: 12px;">
      <!-- Ver -->
      <button type="button" title="Ver detalle" (click)="verCuenta(); $event.stopPropagation()"
        style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #bfdbfe; border-radius: 8px; background: #eff6ff; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
      </button>
      <!-- Editar -->
      <button type="button" title="Editar" (click)="actualizar(); $event.stopPropagation()"
        style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #bfdbfe; border-radius: 8px; background: #eff6ff; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
      </button>
      <!-- Eliminar -->
      <button type="button" title="Eliminar" (click)="inactivarCuenta(); $event.stopPropagation()"
        style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
      </button>
    </div>

    <!-- Flecha expandir mobile -->
    <mat-icon class="lg:hidden" style="color: #9ca3af; flex-shrink: 0; margin-left: 8px; transition: transform 0.2s ease;"
      [style.transform]="isExpanded ? 'rotate(180deg)' : 'rotate(0)'">
      expand_more
    </mat-icon>
  </div>

  <!-- Cuerpo expandible (solo mobile, lg:hidden) -->
  <div class="lg:hidden" *ngIf="isExpanded">
    <!-- Detalles -->
    <div style="padding: 0 16px 12px; border-top: 1px solid #f3f4f6;">
      <div class="grid grid-cols-2 gap-3" style="padding-top: 12px;">
        <!-- Identificador -->
        <div>
          <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Identificador</span>
          <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827; word-break: break-all;">{{ cuenta?.identificador }}</p>
        </div>
        <!-- Tipo -->
        <div>
          <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo</span>
          <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta?.esEmpresa ? 'Empresa' : 'Individuo' }}</p>
        </div>
        <!-- Banco -->
        <div>
          <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Banco</span>
          <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta?.banco?.nombre }}</p>
        </div>
        <!-- Número de cuenta (solo BOFA) -->
        <div *ngIf="cuenta?.banco?.codigoBanco !== 'ZELLE' && cuenta?.numeroCuenta">
          <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nro. Cuenta</span>
          <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta?.numeroCuenta }}</p>
        </div>
      </div>
    </div>

    <!-- Acciones mobile -->
    <div style="padding: 10px 16px; border-top: 1px solid #f3f4f6; display: flex; gap: 8px;">
      <button type="button" (click)="verCuenta(); $event.stopPropagation()"
        style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
        Ver
      </button>
      <button type="button" (click)="actualizar(); $event.stopPropagation()"
        style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
        Editar
      </button>
      <button type="button" (click)="inactivarCuenta(); $event.stopPropagation()"
        style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
        Eliminar
      </button>
    </div>
  </div>
</div>
